import KeenSlider from "keen-slider";

class ButtonSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.slidesContainer = this.querySelector(".keen-slider");
    this.slides = this.querySelectorAll(".keen-slider__slide");
    const options = JSON.parse(this.getAttribute("data-slider-options"));
    const buttonId = this.getAttribute("data-button-id");

    const useIndexButtons = this.slidesContainer.getAttribute(
      "data-use-index-btns"
    );

    // get left, right nav buttons and add click events to them
    const navButtons = this.querySelectorAll(".slider-btn");
    if (navButtons.length > 0) {
      navButtons[0].addEventListener("click", () => slider.prev());
      navButtons[1].addEventListener("click", () => slider.next());
    }

    // get dots and add click events to them
    let dots = this.querySelectorAll(".dot");

    const handleDotClick = (index) => () => {
      slider.moveToIdx(index, true);
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[index].classList.add("active");
    };

    if (dots.length > 0) {
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    }

    // get buttons that update slider slides and add events to them
    const handleClick = () => {
      setTimeout(() => slider.update(options, 0), 0);
      let dots = this.querySelectorAll(".dot");
      if (dots.length === 0) return;
      dots = this.querySelectorAll(".dot");
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    };

    let buttons;
    if (buttonId) {
      buttons = document.querySelectorAll(`.${buttonId}`);
    } else {
      buttons = this.querySelectorAll(".button__tab");
    }
    buttons.forEach((button) => button.addEventListener("click", handleClick));
    buttons.forEach((button) => button.addEventListener("focus", handleClick));

    if (useIndexButtons === "true") {
      // get index buttons and move the active slide to that index
      const handleIndexButtonClick = (index) => () => {
        slider.moveToIdx(index, true);
      };

      const indexButtons = document.querySelectorAll(".index-btn");

      if (indexButtons.length > 0) {
        indexButtons.forEach((button, index) => {
          button.addEventListener("click", handleIndexButtonClick(index));
        });
      }
    }

    // get slide count elements and update them on events
    const slideCurrent = this.querySelector(".slide-current");
    const slideTotal = this.querySelector(".slide-total");

    const slider = new KeenSlider(this.slidesContainer, options);

    slider.on("updated", () => {
      this.slides.forEach((slide) => {
        if (slideCurrent) {
          slideCurrent.textContent = slider.track.details.rel + 1;
        }
        if (slideTotal) {
          slideTotal.textContent = slider.track.details.slides.length;
        }
        const index = parseInt(slide.getAttribute("data-active-slide"));
        if (index) {
          slider.moveToIdx(index, true);
        }
      });
    });
    // update dot classes on events
    slider.on("optionsChanged", () => {
      dots = this.querySelectorAll(".dot");
      if (dots.length === 0) return;
      dots.forEach((dot, index) => {
        dot.addEventListener("click", handleDotClick(index));
        dots[0].classList.add("active");
      });
    });
    slider.on("slideChanged", () => {
      if (slideCurrent) {
        slideCurrent.textContent = slider.track.details.rel + 1;
      }
      if (slideTotal) {
        slideTotal.textContent = slider.track.details.slides.length;
      }
      if (dots.length === 0) return;
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[slider.track.details.rel].classList.add("active");
    });

    setTimeout(() => {
      if (slider) {
        slider.update();
      }
    }, 0);
  }
}

/*
  Register the element.
  Set timeout allows us to grab the dynamic classes added by Alpine
  after they have been added to the DOM.
*/
setTimeout(() => {
  if (!customElements.get("button-slider"))
    customElements.define("button-slider", ButtonSlider);
}, 0);
